import {Controller} from "@hotwired/stimulus"
import {VoiceRecorder} from 'capacitor-voice-recorder'

export default class extends Controller {
  static values = {
    phraseNumber: Number
  }

  async connect() {
    const permission = await VoiceRecorder.requestAudioRecordingPermission();
    this.isBusy = false;

    if (!permission.value) {
      alert('Please allow microphone usage to record voice sample');

      Turbo.visit('/stories')
    }
  }

  async start(event) {
    if (this.isBusy) {
      return;
    }

    this.isBusy = true;

    let status = await VoiceRecorder.getCurrentStatus();
    if (status['status'] !== 'NONE') {
      this.isBusy = false;
      return;
    }

    event.target.classList.add('bg-red-600');
    event.target.classList.remove('loading');
    await VoiceRecorder.startRecording();
    this.startStopwatch();
  }

  async stop(event) {
    let status = await VoiceRecorder.getCurrentStatus();
    if (status['status'] === 'NONE' || !this.isBusy) {
      return;
    }

    event.target.classList.remove('bg-red-600');
    event.target.classList.add('loading');
    this.stopStopwatch();

    const result = await VoiceRecorder.stopRecording();

    if (result.value && result.value.recordDataBase64) {
      if (result.value.msDuration < 3000) {
        alert('Too short!');
        setTimeout(() => {
          this.isBusy = false;
          event.target.classList.toggle('loading');
          this.resetStopwatch();
          document.querySelector('#stopwatch').classList.toggle('hidden');
        }, 500);
        return;
      }

      debugger;

      const response = await fetch('/voice', {
        method: 'POST', headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          phrase_number: this.phraseNumberValue,
          record: 'data:' + result.value.mimeType + ';base64,' + result.value.recordDataBase64
        })
      });

      Turbo.visit('/voice/new?phrase_number=' + (this.phraseNumberValue + 1));

      // Вы можете воспроизвести или сохранить эту запись
      // const audioBlob = base64ToBlob(audioBase64, 'audio/wav');
      // const audioUrl = URL.createObjectURL(audioBlob);
      // const audio = new Audio(audioUrl);
      // audio.play();
    }
  }

  startStopwatch() {
    if (!this.stopwatchInterval) {
      this.startTime = new Date().getTime(); // get the starting time by subtracting the elapsed paused time from the current time
      this.stopwatchInterval = setInterval(this.updateStopwatch.bind(this), 1000); // update every second
      document.querySelector('#stopwatch').classList.toggle('hidden');
    }
  }

  stopStopwatch() {
    clearInterval(this.stopwatchInterval); // stop the interval
    this.elapsedPausedTime = new Date().getTime() - this.startTime; // calculate elapsed paused time
    this.stopwatchInterval = null; // reset the interval letiable
  }

  resetStopwatch() {
    this.stopStopwatch(); // stop the interval
    this.elapsedPausedTime = 0; // reset the elapsed paused time letiable
    document.querySelector("#stopwatch p").innerHTML = "00:00"; // reset the display
  }

  updateStopwatch() {
    let currentTime = new Date().getTime(); // get current time in milliseconds
    let elapsedTime = currentTime - this.startTime; // calculate elapsed time in milliseconds
    let seconds = Math.floor(elapsedTime / 1000) % 60; // calculate seconds
    let minutes = Math.floor(elapsedTime / 1000 / 60) % 60; // calculate minutes
    document.querySelector("#stopwatch p").innerHTML = this.zeroPad(minutes) + ":" + this.zeroPad(seconds); // update the display
  }

  zeroPad(number) {
    // add a leading zero if the number is less than 10
    return (number < 10 ? "0" : "") + number;
  }
}
